import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CommonService } from '../common.service';
import { WebcallsService } from 'src/app/webcalls.service';
import { DataproviderService } from 'src/app/dataprovider.service';
import { ProgressiveBarService } from 'src/app/shared/progressive-bar/progressive-bar.service';
import { TooltipTypesEnum } from 'src/app/shared/tooltip-types.enum';

@Component({
  selector: 'app-room',
  templateUrl: './room.component.html',
  styleUrls: ['./room.component.scss', './room.component.responsive.scss'],
  host: {
    class: 'center-route-content d-block p-x-page p-t-room bg-standard p-b-104'
  }
})
export class RoomComponent implements OnInit {
  title:    string = "b2c.IDS_ROOMS";
  subtitle: string = "b2c.IDS_ROOMS_SUB";
  showSubtitle: boolean = true;
  subtitleInfo: string = "b2c.IDS_ROOMS_GUIDE";
  showSubtitleInfo: boolean = true;
  question: string = "b2c.IDS_ROOMS_QUE";
  activePage: string = "rooms";
  nextPage: string = "systems";
  eventCategory: string = "IDS_GTAG_CATEGORY";
  eventLabel: string = "IDS_ROOMS_LABEL_".concat(this.ds.getWhatToDo().name.toString());
  tooltipType: TooltipTypesEnum = TooltipTypesEnum.INFO;
  dataEntries:  any    = [];
  showSidebar: boolean = false;

  @ViewChild("container") containerRef: ElementRef;

  constructor(
    private cs: CommonService,
    private ws: WebcallsService,
    private ds: DataproviderService,
    private progressiveBarService: ProgressiveBarService
  ) {
    this.cs.setParams(
      this.title,
      this.subtitle,
      this.question,
      this.activePage,
      this.nextPage,
      false,
      true,
      false,
      true,
      null,
      false,
      false,
      this.eventCategory,
      this.eventLabel,
      false,
      null,
      true,
      this.showSubtitle,
      this.showSubtitleInfo,
      '',
      this.subtitleInfo
    );
    this.progressiveBarService.setProgressiveBarLengthByPageIndex(3);
  }

  ngOnInit() {
    if ((this.ds.getCachedRooms() == undefined) || (this.ds.getCachedRooms().length == 0)){
      this.wsCall();
    }
    else {
      this.dataEntries = this.ds.getCachedRooms();
      this.initSelection();
      this.preloadNextStep();
    }
  }

  wsCall(){
    this.ws.getListOfDistinctRoomTypes(this.ds.getLocalizationID()).subscribe( data => {
      this.dataEntries = data;
      this.ds.setCachedRooms(data);
      this.initSelection();
    });
    this.preloadNextStep();
  }

  preloadNextStep() {
    /* preload data next steps: Systems */
    this.ws.getSystems(this.ds.getLocalizationID()).subscribe( data => {
      if (Array.isArray(data)){
        this.ds.setCachedSystems(data);
      }
    });
  }

  initSelection() {
    let selectedRooms = this.ds.getCachedRooms();

    if (selectedRooms == undefined){
      selectedRooms = this.ds.getCachedRooms();// this.ds.getCachedSystems();
    }

    this.dataEntries.forEach(d => {
      let room = null;
      if (selectedRooms) {
        room = selectedRooms.find(sr => { return sr.RoomGroupName == d.RoomGroupName });
        if (room && room.SubRooms.length > 0 && d.SubRooms.length > 0 && room.SubRooms[0].ID == d.SubRooms[0].ID) {
          this.onRoomSpinnerUpd((room.SubRooms[0].Quantity | 0), d.SubRooms[0].ID);
        } else {
          if (d.SubRooms.length > 0 && !d.SubRooms[0].Quantity) {
            this.onRoomSpinnerUpd(0, d.SubRooms[0].ID);
          }
          console.warn("sub rooms not equals");
        }
      } else {
        if (d.SubRooms.length > 0 && !d.SubRooms[0].Quantity) {
          this.onRoomSpinnerUpd(0, d.SubRooms[0].ID);
        }
      }
    });
    this.cs.updateNextBtn(this.canConfirm());
  }

  canConfirm(){
    let f: boolean = false;
    for (let room of this.dataEntries) {
      if(room.SubRooms[0].Quantity > 0){
        f = true;
      }
    }
    return f;
  }

  onRoomSpinnerUpd(qta: number, id: number){
    for (let room of this.dataEntries) {
      if(room.SubRooms[0].ID == id){
        room.SubRooms[0].Quantity = qta;
      }
    }
    this.ds.setCachedRooms(this.dataEntries);
    this.cs.updateNextBtn(this.canConfirm());

    let listChooise: [{ key: string; value: number }];
    this.dataEntries.forEach(de => {
      let key = "STEP_1_" + de.RoomGroupName;
      let value = 0;
      if (de.SubRooms.length>0){
        value = de.SubRooms[0].Quantity !== undefined ? de.SubRooms[0].Quantity : 0;
      }
      if (listChooise == undefined)
        listChooise = [{ key: key, value: value }];
      else
        listChooise.push({ key: key, value: value });
    });
    this.cs.setGASelectionEvent("step_1", listChooise);
  }

  onCloseTooltip() {
    this.showSidebar = false;
  }
}
